<template>
  <div class="page page-service">
    <section class="section">
      <div class="section-inner">
        <div class="section-header">
          <h2 class="section-title">在线客服</h2>
          <p class="section-subtitle">为您提供便捷、专业、连续的技术与业务支持。</p>
        </div>
        <div class="service-body">
          <p class="tip">
            您可以通过以下方式获得支持：在线客服、工单系统、电话与邮件。我们将根据问题紧急程度匹配合适的处理路径。
          </p>
          <ul class="channels">
            <li>在线客服：工作日 9:00-18:00</li>
            <li>技术工单：适用于功能咨询、故障上报、需求反馈等场景。</li>
            <li>电话支持：重大故障及紧急问题可直接致电值班工程师。</li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ServicePage'
}
</script>

<style scoped>
.page {
  background: #f4f8fc;
}

.service-body {
  background: #ffffff;
  border-radius: 18px;
  padding: 22px 24px 24px;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.1);
  font-size: 14px;
  color: #52606d;
  line-height: 1.9;
}

.tip {
  margin-bottom: 10px;
}

.channels {
  padding-left: 18px;
}
</style>

